import ClickableTile from '@/SearchResults/ClickableTile';
import { useIsMobile } from '~/contexts/DeviceContext';
import CarIcon from '~/icons/CarIcon';
import BlueButton from '~/styles/Button/BlueButton';
import StyledTile from '../components/StyledTile.style';
import TextLines from '../components/TextLines';

export default function TradeYourCarTile() {
  const isMobile = useIsMobile();

  return (
    <ClickableTile
      link="/sellyourcar"
      tileId="tradetile"
      name="TradeinTile"
      smallerSize={isMobile}
    >
      <StyledTile>
        <CarIcon />
        <TextLines top="trade in your car" bottom="with carvana" />
        <BlueButton>GET YOUR OFFER</BlueButton>
      </StyledTile>
    </ClickableTile>
  );
}
